import { leftSideActions } from '@appStore/reducers/leftSideMenu'
import store from '@appStore/store'
import { type LoaderFunctionArgs, redirect } from 'react-router-dom'

function setActiveSide(id: number | string) {
	const action = leftSideActions.setActive(id)
	store.dispatch(action)
}

function setIdActive({ params }: LoaderFunctionArgs, key = 'id') {
	const id = params[key]

	const isValid = id && typeof id === 'string'

	if (!isValid) {
		return redirect('/404')
	}

	const action = leftSideActions.setActive(id)
	store.dispatch(action)
}

export { setActiveSide, setIdActive }
